/* eslint-disable react/jsx-pascal-case */
// HorizontalListing.js
import React from "react";
import ListItem_Preview from "./ListItem_Preview";
import "../styles/global.css";
import ShopButton from "./ShopButton";
import { useNavigate } from "react-router-dom";

const breakpoints = [390, 755]
const mq = breakpoints.map(bp => `@media (min-width: ${bp}px)`)

const HorizontalListing_Homepage = ({
  title,
  products,
  categoryLink,
  limit = 10,
  showBottomLink = false,
  arrow = false,
  buttonText = "Shop All",
  noProductsMessage = "No products found",
  ribbonSettings,
}) => {
  const navigate = useNavigate();

  const filteredAndSortedProducts = products.sort((a, b) => {
    const aRow = a.order_category_row || 0;
    const bRow = b.order_category_row || 0;

    if (aRow > 0 && bRow > 0) {
      return aRow - bRow;
    } else if (aRow > 0) {
      return -1;
    } else if (bRow > 0) {
      return 1;
    }
    return 0;
  });

  return (
    <div className="horizontal-listing" style={{}}>
      <div css={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0 10px 10px 10px" }}>
        <div css={styles.title}>{title}</div>
      </div>
      <div className="" css={{ ...styles.container, padding: "0 10px" }}>
        {products && products.length > 0 ? (
          <>
            {filteredAndSortedProducts.slice(0, limit).map((product, index) => (
              <div key={product.id || index} css={styles.item}>
                <ListItem_Preview product={product} index={index} dataMultiple={products} priceTheme={"preview"} ribbonSettings={ribbonSettings} />
              </div>
            ))}
          </>
        ) : (
          <p style={styles.empty}>{noProductsMessage}</p>
        )}
      </div>

      {showBottomLink && (
        <div style={{ padding: "0 10px" }}>
          <ShopButton text={buttonText} containerStyles={styles.shop.button}
            buttonStyle={styles.shop.text} theme="dark" url={categoryLink} arrow={arrow} onClick={() => navigate(categoryLink)} />
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "row",
    overflowX: "auto",
    padding: "10px 0",
    gap: "10px",
  },
  title: {
    fontSize: "1.4rem",
    fontWeight: 700,
    display: "flex",
    color: "black",
    [mq[1]]: {
      fontSize: "1.75rem",
    },
  },
  item: {
    flex: "0 0 auto",
    maxWidth: "120px",
    [mq[0]]: {
      maxWidth: "158px",
    },
    [mq[1]]: {
      maxWidth: "208px",
    },
  },
  empty: {
    fontSize: "1rem",
    color: "gray",
    marginLeft: "10px",
    marginBottom: "20px",
  },
  showMore: {
    width: "120px",
    height: "120px",
    display: "flex",
    backgroundColor: "#f5f5f5",
    margin: "15px 0",
    borderRadius: "8px",
    justifyContent: "center",
    alignItems: "center",
    fontSize: 12,
    color: "gray",
    cursor: "pointer",
  },
  //
  backButtonContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  backButtonText: {
    fontSize: ".9rem",
    fontWeight: "600",
    color: "#1E1E1E",
    marginRight: "5px",
  },
  backButton: {
    display: "flex",
    width: "28px",
    height: "28px",
    borderRadius: "28px",
    justifyContent: "center",
    alignItems: "center",
    border: "2px solid black",
    flexDirection: "row",
  },
  shop: {
    button: {
      maxWidth: "380px",
      margin: "10px auto",
    },
    text: {
      fontSize: "1rem",
      lineHeight: "1rem",
      [mq[1]]: {
        fontSize: "1.25rem",
        lineHeight: "1.25rem",
      },
    }
  }
};

export default HorizontalListing_Homepage;
